// extracted by mini-css-extract-plugin
export default {"entries":"style_entries__7vEL2","entries__title":"style_entries__title__K8fqY","entries__content":"style_entries__content__+73Fi","entries__list":"style_entries__list__0O81e"};